'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _analytics;

exports.default = reducer;
exports.shareFacebook = shareFacebook;
exports.openSubscribe = openSubscribe;
exports.subscribeNextStep = subscribeNextStep;
exports.subscribeEmail = subscribeEmail;
exports.openWeChatPopup = openWeChatPopup;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OPEN_SUBSCRIBE = 'redux-frontend/popup/OPEN_SUBSCRIBE';
var SUBSCRIBE_NEXT_STEP = 'redux-frontend/popup/SUBSCRIBE_NEXT_STEP';
var SUBSCRIBE_EMAIL = 'redux-frontend/popup/SUBSCRIBE_EMAIL';
var SUBSCRIBE_EMAIL_SUCCESS = 'redux-frontend/popup/SUBSCRIBE_EMAIL_SUCCESS';
var SUBSCRIBE_EMAIL_FAIL = 'redux-frontend/popup/SUBSCRIBE_EMAIL_FAIL';
var SHARE_FB_8 = 'redux-frontend/popup/SHARE_FB_8';

var OPEN_WECHAT_POPUP = 'redux-frontend/popup/OPEN_WECHAT_POPUP';

var initialState = {
  step: 1,
  openSubscribe: false,
  isOpenWeChatPopup: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case OPEN_SUBSCRIBE:
      return (0, _extends3.default)({}, state, {
        openSubscribe: action.open
      });
    case SUBSCRIBE_NEXT_STEP:
      return (0, _extends3.default)({}, state, {
        step: state.step + 1
      });
    case OPEN_WECHAT_POPUP:
      return (0, _extends3.default)({}, state, {
        isOpenWeChatPopup: action.open
      });
    default:
      return state;
  }
}

var analytics = exports.analytics = (_analytics = {}, (0, _defineProperty3.default)(_analytics, OPEN_SUBSCRIBE, function (action, getState) {
  return action.open ? { name: 'Open Subscribe', category: 'Marketing Popup' } : { name: 'Close Subscribe', category: 'Marketing Popup', step: getState().popup.step };
}), (0, _defineProperty3.default)(_analytics, SUBSCRIBE_NEXT_STEP, function (action, getState) {
  return { name: 'Next Step', category: 'Marketing Popup', currentStep: getState().popup.step };
}), (0, _defineProperty3.default)(_analytics, SUBSCRIBE_EMAIL, function (action) {
  return { name: 'Subscribe Email', category: 'Marketing Popup', email: action.email };
}), (0, _defineProperty3.default)(_analytics, SHARE_FB_8, function () {
  return { name: 'Share Facebook For 8%', category: 'Marketing Popup' };
}), _analytics);

function shareFacebook() {
  return {
    type: SHARE_FB_8
  };
}

function openSubscribe() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_SUBSCRIBE,
    open: open
  };
}

function subscribeNextStep() {
  return {
    type: SUBSCRIBE_NEXT_STEP
  };
}

function subscribeEmail(email) {
  return {
    types: [SUBSCRIBE_EMAIL, SUBSCRIBE_EMAIL_SUCCESS, SUBSCRIBE_EMAIL_FAIL],
    promise: function promise(client) {
      return client.post('/mail/subscribe', { data: { email: email } });
    },
    email: email
  };
}

function openWeChatPopup() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_WECHAT_POPUP,
    open: open
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/popup.js
// module id = 266
// module chunks = 47